//Constants for INBOUND_TALLYNUMBER
export const INBOUND_TALLY_REQUEST = 'INBOUND_TALLY_REQUEST'
export const INBOUND_TALLY_SUCCESS = 'INBOUND_TALLY_SUCCESS'
export const INBOUND_TALLY_FAIL = 'INBOUND_TALLY_FAIL'

//Constants for INBOUND_ITEM
export const INBOUND_LOCATION_REQUEST = 'INBOUND_LOCATION_REQUEST'
export const INBOUND_LOCATION_SUCCESS = 'INBOUND_LOCATION_SUCCESS'
export const INBOUND_LOCATION_FAIL = 'INBOUND_LOCATION_FAIL'

//Constants for INBOUND_ITEM
export const INBOUND_SAVE_REQUEST = 'INBOUND_SAVE_REQUEST'
export const INBOUND_SAVE_SUCCESS = 'INBOUND_SAVE_SUCCESS'
export const INBOUND_SAVE_FAIL = 'INBOUND_SAVE_FAIL'
